import AdminDashboard from "@/components/admin-dashboard";
import Loader from "@/components/loader";
import ManagerDashboard from "@/components/manager-dashboard";
import { useSystemRole } from "@/lib/role-hooks";

export default function Dashboard() {
  const { isAdmin, isLoading } = useSystemRole();

  if (isLoading) {
    return <Loader className="h-full" />;
  }

  return isAdmin ? <AdminDashboard /> : <ManagerDashboard />;
}
